<template>
  <v-list two-line>
    <v-list-tile v-for="(item, index) in recommendList " :key="item.rank" avatar class="itemDivider">
      <v-list-tile-avatar>
        <ListAvatar
          v-if="parseInt(item.scene_id) !== 13"
          :sceneId="item.scene_id"
          :itemIndex="parseInt(index) - 1"
          :itemTitle="item.name"
          :itemArtist="item.artist_name"
          :itemLyrics="item.lyrics"
          :itemSrc="item.mp3"
          :productId=parseInt(item.product_id)
          :musicPlayerType="'recommend'"
        />
        <PlayBtn
          v-if="parseInt(item.scene_id) === 13"
          :itemIndex="parseInt(index) - 1"
          :itemTitle="item.name"
          :itemArtist="item.artist_name"
          :itemSrc="item.mp3"
          :itemProductId=parseInt(item.product_id)
          :musicPlayerType="'recommend'"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
        <v-list-tile-sub-title @click="artistDetail(item.artist_id)" class="hover-type01">{{ item.artist_name }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <lyrics
        :key="item.artist_id"
        :title="item.name"
        :artist="item.artist_name"
        :dialog="item.lyrics_dialog"
        :lyrics="item.lyrics"
        :introduction="item.introduction"
      />
     <more-btn
      :addIsumBtn="false"
      :addCommentBtn="false"
      :addMusicBtn="false"
      :addListBtn="true"
      :addFavoriteBtn="true"
      :deleteListBtn="false"
      :productId="item.product_id"
     />
    </v-list-tile>
  </v-list>
</template>

<script>
import Lyrics from '@/components/Lyrics.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import ListAvatar from '@/components/atoms/ListAvatar.vue'
import PlayBtn from '@/components/PlayBtn'

export default {
  components: {
    PlayBtn,
    Lyrics,
    MoreBtn,
    ListAvatar
  },
  data: () => ({
    dialog: false,
    recommendList: {}
  }),
  props: ['playListId', 'playlistProducts'],
  watch: {
    playlistProducts (val) {
      let array = val
      let ob = {}
      for (let index in array) {
        if (array.hasOwnProperty(index)) {
          let rank = array[index].rank
          ob[rank] = array[index]
          array[index].rank = array[index].rank - 1
        }
      }
      this.recommendList = ob
      this.$store.commit('recommendListModuleUpdateRecommendedList', this.recommendList)
    }
  },
  methods: {
    /**
     * 詳細ボタンをクリックしたときの処理
     **/
    artistDetail (artistId) {
      this.$router.push({path: '/home/artist/detail/' + artistId})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RecommendedList.vue